import { createFileRoute } from '@tanstack/react-router'

import { CommunitiesPage } from '@/features/communities'

export const Route = createFileRoute('/_authenticated/benefits/communities/')({
  component: CommunitiesPage,
})
